import { render, staticRenderFns } from "./FeaturedBan.vue?vue&type=template&id=2be08adc&scoped=true&"
import script from "./FeaturedBan.vue?vue&type=script&lang=js&"
export * from "./FeaturedBan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be08adc",
  null
  
)

export default component.exports